import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = [
    "street",
    "street_other",
    "city",
    "state",
    "zip",
    "country",
    "county",
  ];

  static COUNTY_CLEANUP_REGEX =
    /\b(County|Parish|Borough|Municipality|District)\b/gi;

  connect() {
    console.log("Address Controller connected");
  }

  initMaps() {
    if (!this.streetTarget) {
      console.log("Street input not found");
      return;
    }

    if (!window.google) {
      console.error("Google Maps API is not loaded");
      return;
    }

    this.streetTarget.addEventListener("focus", (event) => {
      event.target.setAttribute("autocomplete", "new-password");
    });

    this.autocomplete = new window.google.maps.places.Autocomplete(
      this.streetTarget,
      {
        fields: ["address_components"],
        types: ["address"],
      },
    );
    this.autocomplete.addListener(
      "place_changed",
      this.placeSelected.bind(this),
    );
    console.log("AutoComplete initialized");
    this.mapInit = true;
  }

  placeSelected() {
    const place = this.autocomplete.getPlace();

    let address1 = "";
    let postcode = "";
    for (const component of place.address_components) {
      const componentType = component.types[0];

      switch (componentType) {
        case "street_number":
          address1 = `${component.long_name} ${address1}`;
          break;
        case "route":
          address1 += component.short_name;
          break;
        case "subpremise":
          if (this.street_otherTarget) {
            this.street_otherTarget.value = `#${component.long_name.toUpperCase()}`;
          }
          break;
        case "postal_code":
          postcode = `${component.long_name}${postcode}`;
          break;
        case "postal_code_suffix":
          postcode = `${postcode}-${component.long_name}`;
          break;
        case "locality":
          if (this.cityTarget) {
            this.cityTarget.value = component.long_name;
          }
          break;
        case "administrative_area_level_1":
          if (this.stateTarget) {
            this.stateTarget.value = component.short_name;
          }
          break;
        case "administrative_area_level_2":
          if (this.countyTarget) {
            this.countyTarget.value = this.cleanCountyName(component.long_name);
          }
          break;
        case "country":
          if (this.countryTarget) {
            this.countryTarget.value =
              component.short_name === "US" ? "US" : component.short_name;
          }
          break;
      }

      if (this.streetTarget) {
        this.streetTarget.value = address1;
      }
      if (this.zipTarget) {
        this.zipTarget.value = postcode;
      }
    }
  }

  cleanCountyName(countyName) {
    return countyName.replace(this.constructor.COUNTY_CLEANUP_REGEX, "").trim();
  }
}
